import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PaymentsService } from 'src/app/services/core/payments/payments.service';
import { sweetAlert } from 'src/app/utils/swal';

@Component({
  selector: 'app-transaction-refund-modal',
  templateUrl: './transaction-refund-modal.component.html',
  styleUrls: ['./transaction-refund-modal.component.css']
})
export class TransactionRefundModalComponent {
  @Input() transaction: any;
  @Output() closeModal = new EventEmitter<any>();

  transactionDetails: any = [];
  refundForm!: FormGroup
  submitted = false;


  constructor(
    private fb: FormBuilder,
    private paymentService: PaymentsService,
  ) {
    this.refundForm = this.fb.group({
      amount: ['', Validators.required],
      reason: ['', Validators.required],
      allowFullRefund: [false]
    })
  }

  ngOnInit() {
  }
  onAllowFullRefundChange(event: Event) {
    const allowFullRefundChecked = (event.target as HTMLInputElement).checked;
    if (allowFullRefundChecked) {
      this.refundForm.patchValue({
        amount: (this.transaction.amount?this.transaction.amount/100 :0 ) - (this.transaction?.refundedMoney?.amount ?this.transaction?.refundedMoney?.amount/100 :0),

      });
    } else {
      this.refundForm.patchValue({
        amount: '',

      });
    }
  }


  async onSave() {
    this.submitted = true;
    if (this.refundForm.valid) {
      const result = await sweetAlert(
        "Alert",
        `Are you sure you want to refund this amount?`,
        "warning",
        "Yes",
        "No"
      );
      if (result.value) {
        const { allowFullRefund, ...formValues } = this.refundForm.value;
        this.paymentService.refundPayment(this.transaction?.trip?.id, {...formValues, transactionId:this.transaction?.squarePaymentId}).subscribe((data) => {
          this.closeModal.emit({success:true})
          sweetAlert("Success", "Amount has been successfully refunded.", "success", "OK");
        }, (err) => {
          sweetAlert("Error", err, "error", "OK");
        })
      }

    } else {
      console.log("Form is invalid");
    }
  }
  onCloseModal() {
    this.closeModal.emit();
  }
}
